import React from 'react';
import { useHistory } from 'react-router-dom';
import scaleSize from 'utils/scale-size';
import styled from 'styled-components/macro';
import BackButton from 'components/BackButton';

export const StyledBlock = styled.div`
  width: ${scaleSize(680)}px;
  margin: ${scaleSize(34)}px auto;
`;

const BaseLoginPage = ({ children }) => {
  const history = useHistory();

  return (
    <>
      <BackButton onEnter={history.goBack} />
      <StyledBlock>{children}</StyledBlock>
    </>
  );
};

export default BaseLoginPage;
